/* OA Scroll Reveal — generieke fade+slide-up bij scroll
   Elementen met [data-oa-reveal] worden geanimeerd zodra ze in viewport komen.
   Optioneel: data-oa-reveal-delay="80" voor delay (ms) per child.
   By Online Actief — online-actief.nl */
(function () {
  'use strict';

  function init(root) {
    var scope = root || document;
    var targets = scope.querySelectorAll('[data-oa-reveal]:not(.is-visible)');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry, i) {
        if (entry.isIntersecting) {
          var delay = parseInt(entry.target.getAttribute('data-oa-reveal-delay'), 10);
          if (isNaN(delay)) delay = i * 80;
          setTimeout(function () { entry.target.classList.add('is-visible'); }, delay);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    targets.forEach(function (el) { observer.observe(el); });
  }

  function boot() { init(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  /* Re-scan na section reloads in Shopify customizer */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
